module.exports = __webpack_public_path__ + "img/299d931.jpg";